// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"806c3bc1","406":"54567e98","419":"806c3bc1","424":"806c3bc1","834":"806c3bc1"}[chunkId] + ".chunk.css";
};